function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import MiniSearch from 'minisearch';
import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import { StatusDot } from 'components/DataTable';
import Table from 'components/Table';
import SortingIcon from 'components/SortingIcon';
import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import DeleteIcon from 'svg/delete.svg';
import Loupe from 'svg/loupe-light.svg';
import AddIcon from 'svg/add.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import { SCOPE_NAMES } from 'modules/Account/constants';
import { AppContext } from 'context';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import messages from '../../messages';
import * as selectors from '../../selectors';
import AddCountryModal from './AddCountryModal';
import DeleteCountryModal from './DeleteCountryModal';
import styles from './ListCountries.pcss';
var _React_PureComponent;
class ListCountries extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.props.onFetchCountries();
        this.props.onFetchLanguages();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isFetchInProgress && !this.props.isFetchInProgress) {
            this.miniSearch.removeAll();
            this.miniSearch.addAll(this.props.countries);
            this.onRefresh();
            this.onInitialized();
        }
        if (prevProps.isAddCountryInProgress && !this.props.isAddCountryInProgress && !this.props.hasAddCountryErrors) {
            this.props.onFetchCountries();
        }
        if (prevProps.isDeleteCountryProgress && !this.props.isDeleteCountryProgress) {
            this.props.onFetchCountries();
            this.onDeleted();
        }
    }
    onInitialized() {
        this.setState({
            isInitialized: true
        });
    }
    onRefresh() {
        this.setState((state)=>({
                refresh: !state.refresh
            }));
    }
    onClickDeleteCountry(country) {
        if (!country.isActive) {
            this.setState({
                countryToDelete: country
            });
            this.props.onOpenModal(constants.DELETE_COUNTRY_MODAL);
        }
    }
    onDeleted() {
        this.setState({
            countryToDelete: null
        });
        this.props.onCloseModal();
    }
    onEnableFlagSortingClick() {
        switch(this.state.enableFlagSorting){
            case 'default':
                {
                    this.setState({
                        enableFlagSorting: 'desc'
                    });
                    break;
                }
            case 'desc':
                {
                    this.setState({
                        enableFlagSorting: 'asc'
                    });
                    break;
                }
            case 'asc':
                {
                    this.setState({
                        enableFlagSorting: 'default'
                    });
                    break;
                }
            // eslint-disable-next-line no-empty
            default:
                {}
        }
    }
    onCountryNameSortingClick() {
        switch(this.state.countryNameSorting){
            case 'default':
                {
                    this.setState({
                        countryNameSorting: 'desc'
                    });
                    break;
                }
            case 'desc':
                {
                    this.setState({
                        countryNameSorting: 'asc'
                    });
                    break;
                }
            case 'asc':
                {
                    this.setState({
                        countryNameSorting: 'default'
                    });
                    break;
                }
            // eslint-disable-next-line no-empty
            default:
                {}
        }
        this.setState({
            enableFlagSorting: 'default'
        });
    }
    get countries() {
        const { search, enableFlagSorting } = this.state;
        const countries = isEmpty(search) ? this.props.countries : this.miniSearch.search(search);
        return countries.sort((a, b)=>{
            if (enableFlagSorting !== 'default') {
                if (a.isActive !== b.isActive) {
                    if (enableFlagSorting === 'desc') return a.isActive ? -1 : 1;
                    return a.isActive ? 1 : -1;
                }
            }
            return this.orderByEnglishName(a, b);
        });
    }
    get schema() {
        const schema = [
            {
                key: 'englishName',
                labelMessage: ()=>this.renderCountryNameHeader(),
                onClickHeader: ()=>this.onCountryNameSortingClick(),
                renderer: (country)=>/*#__PURE__*/ _jsx("b", {
                        children: country.englishName
                    })
            },
            {
                key: 'code',
                labelMessage: messages.labels.countryCode,
                renderer: (country)=>/*#__PURE__*/ _jsx("p", {
                        children: country.code
                    })
            },
            {
                key: 'isActive',
                labelMessage: ()=>this.renderIsEnabledFlagHeader(),
                onClickHeader: ()=>this.onEnableFlagSortingClick(),
                renderer: (country)=>/*#__PURE__*/ _jsx("div", {
                        children: this.renderIsEnabledFlag(country.isActive)
                    })
            },
            {
                key: 'config',
                renderer: (country)=>this.renderConfigButton(country)
            }
        ];
        if (this.props.canDelete) {
            schema.push({
                key: 'delete',
                renderer: (country)=>this.renderDeleteIcon(country)
            });
        }
        return schema;
    }
    orderByEnglishName(a, b) {
        const { countryNameSorting } = this.state;
        if (countryNameSorting === 'desc' || countryNameSorting === 'default') {
            if (lowerCase(a.englishName) > lowerCase(b.englishName)) {
                return 1;
            }
            if (lowerCase(a.englishName) < lowerCase(b.englishName)) {
                return -1;
            }
        }
        if (countryNameSorting === 'asc') {
            if (lowerCase(a.englishName) < lowerCase(b.englishName)) {
                return 1;
            }
            if (lowerCase(a.englishName) > lowerCase(b.englishName)) {
                return -1;
            }
        }
        return 0;
    }
    renderCountryNameHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.countriesTable__sortingHeader, 'd-flex align-item-center'),
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.countryName)),
                /*#__PURE__*/ _jsx(SortingIcon, {
                    type: this.state.countryNameSorting,
                    className: styles.countriesTable__sortingHeaderIcon
                })
            ]
        });
    }
    renderIsEnabledFlagHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.countriesTable__sortingHeader, 'd-flex align-item-center'),
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.isEnableFlag)),
                /*#__PURE__*/ _jsx(SortingIcon, {
                    type: this.state.enableFlagSorting,
                    className: styles.countriesTable__sortingHeaderIcon
                })
            ]
        });
    }
    renderIsEnabledFlag(isActive) {
        const status = isActive ? 'success' : 'error';
        const labelMessage = isActive ? messages.labels.enable : messages.labels.disable;
        return /*#__PURE__*/ _jsx(StatusDot, {
            status,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage))
        });
    }
    renderDeleteIcon(country) {
        return /*#__PURE__*/ _jsx(DeleteIcon, {
            className: cn(styles.countriesTable__deleteIcon, {
                [styles['countriesTable__deleteIcon--inactive']]: country.isActive
            }),
            onClick: ()=>this.onClickDeleteCountry(country)
        });
    }
    renderConfigButton({ code: countryCode }) {
        return /*#__PURE__*/ _jsx(Button, {
            labelMessage: messages.buttons.config,
            className: "btn--outline",
            type: "link",
            to: this.context.getUrl('country-configuration', {
                countryCode
            })
        });
    }
    renderAddCountryButton() {
        if (!this.props.canAdd) return null;
        return /*#__PURE__*/ _jsx(Button, {
            className: "btn--primary btn--filled",
            onClick: ()=>this.props.onOpenModal(constants.ADD_COUNTRY_MODAL),
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(AddIcon, {
                        className: styles.header__addButton__icon
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.addCountry))
                    })
                ]
            })
        });
    }
    renderSearch() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header__search,
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.searchCountry,
                    value: this.state.search,
                    onChange: (input)=>this.setState({
                            search: input.value
                        })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.search__loupe
                })
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header,
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.countries))
                }),
                this.renderSearch(),
                this.renderAddCountryButton()
            ]
        });
    }
    renderTable() {
        return /*#__PURE__*/ _jsx(Table, {
            idKey: "code",
            className: styles.countriesTable,
            schema: this.schema,
            entities: this.countries,
            page: this.state.page,
            perPage: 10,
            isPerPageOff: true
        });
    }
    renderModals() {
        if (this.props.openModalId === constants.ADD_COUNTRY_MODAL) {
            if (!this.props.canAdd) return null;
            return /*#__PURE__*/ _jsx(AddCountryModal, {
                isInProgress: this.props.isAddCountryInProgress,
                openModalId: this.props.openModalId,
                languageOptions: this.props.languageOptions,
                hasErrors: this.props.hasAddCountryErrors
            });
        }
        if (this.props.openModalId === constants.DELETE_COUNTRY_MODAL && this.state.countryToDelete) {
            return /*#__PURE__*/ _jsx(DeleteCountryModal, {
                country: this.state.countryToDelete,
                onDeleteSuccess: ()=>{}
            });
        }
        return null;
    }
    render() {
        if (!this.state.isInitialized) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.listCountries,
            children: [
                this.renderHeader(),
                this.renderTable(),
                this.renderModals()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            page: 0,
            search: '',
            countryToDelete: null,
            isInitialized: false,
            enableFlagSorting: 'default',
            countryNameSorting: 'default'
        };
        this.miniSearch = new MiniSearch({
            idField: 'code',
            fields: [
                'englishName',
                'code'
            ],
            storeFields: [
                'englishName',
                'code',
                'isActive'
            ],
            searchOptions: {
                fuzzy: 0,
                prefix: true,
                refresh: false
            }
        });
    }
}
_define_property(ListCountries, "contextType", AppContext);
_define_property(ListCountries, "propTypes", {
    // Explicit props
    // Implicit props
    isFetchInProgress: PropTypes.bool,
    isAddCountryInProgress: PropTypes.bool,
    isDeleteCountryProgress: PropTypes.bool,
    hasAddCountryErrors: PropTypes.bool,
    hasDeleteCountryErrors: PropTypes.bool,
    countries: PropTypes.arrayOf(shapes.country),
    languageOptions: PropTypes.arrayOf(shapes.language),
    canDelete: PropTypes.bool,
    canAdd: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onOpenModal: PropTypes.func,
    onCloseModal: PropTypes.func,
    onFetchCountries: PropTypes.func,
    onFetchLanguages: PropTypes.func
});
const mapStateToProps = (state)=>({
        countries: selectors.countries(state),
        languageOptions: selectors.languages(state),
        isFetchInProgress: selectors.isFetchCountriesInProgress(state),
        isAddCountryInProgress: selectors.isAddCountryInProgress(state),
        isDeleteCountryProgress: selectors.isDeleteCountryProgress(state),
        hasAddCountryErrors: selectors.hasAddCountryErrors(state),
        openModalId: App.selectors.modal(state),
        canDelete: Account.selectors.scope(state) === SCOPE_NAMES.SDN_ADMIN,
        canAdd: Account.selectors.scope(state) === SCOPE_NAMES.SDN_ADMIN
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onCloseModal: ()=>dispatch(App.actions.closeModal()),
        onFetchCountries: ()=>dispatch(actions.fetchCountries()),
        onFetchLanguages: ()=>dispatch(actions.fetchLanguages())
    });
const ConnectedListCountries = connect(mapStateToProps, mapDispatchToProps)(ListCountries);
export default withStyles(styles)(ConnectedListCountries);
